export const Http = 'http:'
export const Https = 'https:'
export const Ws = 'ws:'
export const Wss = 'wss:'
export const Blob = 'blob:'
export const File = 'file:'
